import React, { FC, memo, useEffect, useState } from 'react'
import classes from './WorkersContainer.module.scss'
import { userState } from '../../../states/userState'
import { useRecoilValue } from 'recoil'
import { User, WorkerWithDiary } from '../../../types'
import WorkersModal from './modal/WorkersModal'
import { useGetHasDiaryList } from '../../../hooks/api/posts/useGetHasDiaryList'
import { useTheme } from '@mui/material'

type Props = {
  workingDate: { obj: Date; text: string }
  workerList: Array<WorkerWithDiary>
  setWorkerList: React.Dispatch<React.SetStateAction<WorkerWithDiary[]>>
  isSendable: boolean
  setIsSendable: React.Dispatch<React.SetStateAction<boolean>>
  setDefaultFactoryNo: React.Dispatch<React.SetStateAction<number>>
}
const WorkersContainer: FC<Props> = memo((props) => {
  const theme = useTheme()
  const { getHasDiaryList } = useGetHasDiaryList()
  const {
    workingDate,
    workerList,
    setWorkerList,
    setIsSendable,
    isSendable,
    setDefaultFactoryNo,
  } = props
  const user = useRecoilValue<User>(userState)

  const [numberOfExisting, setNumberOfExisting] = useState<number>(
    workerList.filter((worker: WorkerWithDiary) => worker.isDiaryExist).length
  )
  const [isShowModal, setIsShowModal] = useState(false)
  // const [isSendable, setIsSendable] = useState(false); //送信可・不可
  useEffect(() => {
    //リセット
    if (!isShowModal) {
      setWorkerList(user.initialParameters.workersForMultiInput)
    }
  }, [isShowModal])
  //APIフェッチ
  useEffect(() => {
    const fetchHasDiaryList = async () => {
      const workerIdList = workerList.map((worker: WorkerWithDiary) => {
        return Number(worker.workerId)
      })
      const hasDiaryList = await getHasDiaryList(workerIdList, workingDate.text)
      setWorkerList((prevState) => {
        const newState = prevState.map((worker: WorkerWithDiary) => {
          const hasDiary = hasDiaryList?.filter(
            (hasDiary) => hasDiary.workerId === Number(worker.workerId)
          )
          return {
            ...worker,
            isDiaryExist: hasDiary ? hasDiary[0].isDiaryExist : false,
          }
        })
        return newState
      })
    }
    fetchHasDiaryList()
  }, [workingDate])
  useEffect(() => {
    const count = workerList.filter(
      (worker: WorkerWithDiary) => worker.isDiaryExist
    ).length
    setNumberOfExisting(count)
    setIsSendable(count === 0 && workerList.length > 0 ? true : false)
  }, [workerList])
  return (
    <>
      <div className={classes.rootContainer}>
        {numberOfExisting > 0 ? (
          <p
            style={{ color: theme.palette.foreColor.error }}
          >{`合計${workerList.length}名（内入力不可${numberOfExisting}名)`}</p>
        ) : workerList.length == 0 ? (
          <p style={{ color: theme.palette.foreColor.error }}>
            {`合計${workerList.length}名 (入力者がいません)`}
          </p>
        ) : (
          <p style={{ color: theme.palette.foreColor.main }}>
            {`合計${workerList.length}名`}
          </p>
        )}
        <div
          onClick={() => setIsShowModal(true)}
          style={{
            borderRight: `5px solid ${
              isSendable
                ? theme.palette.foreColor.success
                : theme.palette.foreColor.error
            }`,
          }}
        >
          <p>
            {workerList.map((worker: WorkerWithDiary, index: number) => {
              const workerName =
                index !== workerList.length - 1
                  ? worker.workerName + ', '
                  : worker.workerName
              const workerColor = worker.isDiaryExist
                ? theme.palette.foreColor.caution
                : theme.palette.foreColor.light

              return (
                <span
                  key={worker.workerId}
                  style={{ color: workerColor, paddingRight: '5px' }}
                >
                  {workerName}
                </span>
              )
            })}
          </p>
        </div>
      </div>
      {isShowModal && (
        <WorkersModal
          setIsShow={setIsShowModal}
          workerList={workerList}
          setWorkerList={setWorkerList}
          workingDate={workingDate}
          setDefaultFactoryNo={setDefaultFactoryNo}
        />
      )}
    </>
  )
})

export default WorkersContainer
